import React from "react";
import { View, StyleSheet, Text, Link } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  footer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "absolute",
    bottom: 15,
    left: 50,
    right: 50,
    textAlign: "left",
    fontSize: "10px",
    color: "gray",
    borderTopWidth: 1,
    borderTopColor: "#cccccc",
    paddingTop: 5,
  },
});

const Footer = () => (
  <View style={styles.footer} fixed>
    <Text>© Crystin Manufacturing</Text>

    <Text
      fixed
      render={({ pageNumber, totalPages }) =>
        `Page ${pageNumber} of ${totalPages}`
      }
    />
  </View>
);

export default Footer;
